import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from "./pages/EditPage.tsx";
import {useVerifiedPermissions} from "../../hooks/useVerifiedPermissions.ts";


export const ProductsLayout = () => {

    const {allowedActions} = useVerifiedPermissions()


    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes('ListProducts') ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path='add'
                element={
                    allowedActions.includes('CreateProduct') ? (
                        <AddPage/>
                    ) : (
                        <Navigate to='/products'/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes('GetProduct') ? (
                        <EditPage/>
                    ) : (
                        <Navigate to='/products'/>
                    )
                }

            >
            </Route>


        </Routes>
    );
};
